import { topicItems } from '@/mocks/homeData';

const trendStyles: Record<string, { bg: string; text: string; icon: string }> = {
  hot: { bg: 'bg-primary-100', text: 'text-primary-700', icon: 'ri-fire-line' },
  rising: { bg: 'bg-accent-100', text: 'text-accent-700', icon: 'ri-arrow-up-line' },
  stable: { bg: 'bg-secondary-100', text: 'text-secondary-700', icon: 'ri-subtract-line' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3">
            社区热议
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热议话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            水果视频平台社区当前最热门的话题讨论
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-4xl mx-auto">
          {topicItems.map((item) => {
            const style = trendStyles[item.trend] || trendStyles.stable;
            return (
              <div
                key={item.name}
                className="flex items-center justify-between gap-3 p-4 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              >
                <div className="min-w-0">
                  <div className="font-medium text-sm text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                    {item.name}
                  </div>
                  <div className="flex items-center gap-3 mt-1">
                    <span className="text-xs text-foreground-400">{item.posts} 讨论</span>
                    <span className={`inline-flex items-center gap-0.5 text-[10px] font-medium ${style.text}`}>
                      <i className={`${style.icon} text-xs`}></i>
                      {item.heat}
                    </span>
                  </div>
                </div>
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg ${style.bg}`}>
                  <i className={`${style.icon} ${style.text} text-sm`}></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}